import { useT } from '@dia/i18n';
import { loadShell } from '@dia/content';
import { LangToggle, Screen } from '@dia/ui';
import { BackLink } from './parts/BackLink';
import { IslandMap } from './parts/IslandMap';
import { DocArticle, Todo } from './parts/Prose';

const content = loadShell('guest');

/**
 * The island guide: a static SVG map first, then where things are, the
 * snorkel spots off the docks, the sunrise and sunset sides, and the mangrove
 * edge. Public and bundled, so it works with no signal and no sign in.
 */
export function IslandGuide() {
  const { t } = useT();
  const pages = content.section('island');

  return (
    <Screen title={t('guest.island.title')} lede={t('guest.island.lede')} actions={<LangToggle />}>
      <BackLink />
      <div className="flex flex-col gap-8 mt-2">
        <figure className="flex flex-col gap-2">
          <IslandMap />
          <figcaption className="text-inkFaint text-caption">
            {t('guest.island.map_note')} <Todo>TIM TO CONFIRM: real positions for the island map</Todo>
          </figcaption>
        </figure>

        {pages.map((doc) => (
          <DocArticle key={doc.path} doc={doc} />
        ))}
      </div>
    </Screen>
  );
}
